/**
 * Defines comparison operators used on the query in filter buttons.
 */
export var FilterType;
(function (FilterType) {
    FilterType["Equal"] = "=";
    FilterType["NotEqual"] = "<>";
    FilterType["Greater"] = ">";
    FilterType["Smaller"] = "<";
    FilterType["Contains"] = "contains";
    FilterType["Like"] = "like";
    FilterType["StartsWith"] = "startsWith";
    FilterType["GreaterEqual"] = ">=";
    FilterType["SmallerEqual"] = "<=";
})(FilterType || (FilterType = {}));
;
